// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"515e3be6","453":"0e41477a"}[chunkId] + ".chunk.js";
};